module.exports = {
      id: "media-placeholder-usage",
      viewBox: "0 0 632 421",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#media-placeholder",
      toString: function () {
        return this.url;
      }
    }